import {
  QIcon_chevron_bold_right,
  QIcon_fire,
  QIcon_noconversation,
  QIcon_openbook,
  QIcon_pen,
} from '@repo/icons/index'
import React from 'react'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import { n_lesson_prep } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { locationMoveLocaleNewTab } from '../../../../modules/utils'

interface LessonOverviewNewUserProps {
  setPrepAble: React.Dispatch<React.SetStateAction<boolean>>
}

const LessonOverviewNewUserModal = ({ setPrepAble }: LessonOverviewNewUserProps) => {
  const { t, isLocaleKO } = useTranslation()
  const isWebview = useIsWebview()

  const onClickMorePrepButton = () => {
    if (isLocaleKO) {
      locationMoveLocaleNewTab('/student/landing/blog/ringle-lesson-prep')
    } else {
      locationMoveLocaleNewTab('/student/landing/blog/ringle-lesson-prep-en')
    }
  }
  return (
    <div className="mt-[24px] flex flex-col space-y-[36px]">
      <div className="flex flex-col">
        <div className="flex flex-col space-y-[20px] rounded-[8px] bg-gray-50 p-[16px]">
          <div className="flex flex-col space-y-[7px]">
            {' '}
            {/**dddddddd */}
            <div className="flex space-x-[4px]">
              <QIcon_openbook className="h-24 w-24 text-black" />
              <span className="text-[14px] font-bold text-black">{t(n_lesson_prep.overview.info_insight)}</span>
            </div>
            <span className="pl-28 text-[14px] font-medium text-gray-600">
              {t(n_lesson_prep.overview.info_insight_desc)}
            </span>
          </div>{' '}
          {/**dddddddd */}
          <div className="flex flex-col space-y-[7px]">
            {' '}
            {/**dddddddd */}
            <div className="flex space-x-[4px]">
              <QIcon_noconversation className="h-24 w-24 text-black" />
              <span className="text-[14px] font-bold text-black">{t(n_lesson_prep.overview.info_question)}</span>
            </div>
            <div className="pl-28 text-[14px] font-medium text-gray-600">
              {t(n_lesson_prep.overview.info_question_desc)}
            </div>
          </div>{' '}
          {/**dddddddd */}
          <div className="flex flex-col space-y-[7px]">
            {' '}
            {/**dddddddd */}
            <div className="flex space-x-[4px]">
              <QIcon_pen className="h-24 w-24 text-black" />
              <span className="text-[14px] font-bold text-black">{t(n_lesson_prep.overview.info_answer)}</span>
            </div>
            <div className="pl-28 text-[14px] font-medium text-gray-600">
              {t(n_lesson_prep.overview.info_answer_desc)}
            </div>
          </div>{' '}
          {/**dddddddd */}
        </div>
        <div className="mt-[12px] mb-[20px] flex rounded-[8px] bg-purple-50 p-[16px]">
          <span className="text-[14px] font-medium text-gray-500">{t(n_lesson_prep.overview.info_free)}</span>
        </div>
        {!isWebview && (
          <div className="flex cursor-pointer items-center space-x-[2px]" onClick={onClickMorePrepButton}>
            <span className="text-[14px] font-bold text-purple-500">{t(n_lesson_prep.overview.info_tip)}</span>
            <QIcon_chevron_bold_right className="h-16 w-16 text-purple-500" />
          </div>
        )}
      </div>

      <div className="flex items-center justify-center space-x-[4px]">
        <QIcon_fire className="text-gray-900" />
        <span className="text-[14px] font-bold text-gray-900">{t(n_lesson_prep.overview.info_start)}</span>
      </div>
    </div>
  )
}

export default React.memo(LessonOverviewNewUserModal)
